import axios from "axios";
import { api_s2 } from "../config";

axios.defaults.baseURL = api_s2.baseURL;
axios.defaults.headers.common["PymbleClientId"] = "pastoral-admin";
// Serialise array params as repeated keys (`tags=a&tags=b`) rather than the
// axios default bracketed form (`tags[]=a`), which FastAPI's `list[str]` query
// params do not read.
axios.defaults.paramsSerializer = { indexes: null };

axios.interceptors.response.use(
	(response) => response,
	async (error) => {
		const expectedErr =
			error.response &&
			error.response.status >= 400 &&
			error.response.status < 500;

		if (!expectedErr) {
			console.error("httpService error:", error);
		}

		return Promise.reject(error);
	}
);

const httpService = {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete,
	head: axios.head,
	request: axios.request,
};

export default httpService;
